/**
 * What appears in the sidebar and the mobile tab bar, in order.
 *
 * Entries reference a view key rather than a path, so a screen that moves
 * moves in `views.ts` alone. Each item still checks its own visibility through
 * `useCanSee`, which is what keeps a link out of the navigation when the view
 * behind it is gated.
 *
 * kdoshr-app keys this by role and unions the lists for a user with several.
 * kdoshsop has no roles, so it is one ordered list. Adding roles later means
 * turning this into `Record<string, NavigationEntry[]>` and giving the two
 * layout components a union helper; nothing else changes.
 */
import { Home } from 'lucide-react';
import type { ReactNode } from 'react';

import type { NavigableViewKey } from './views';

export interface NavigationEntry {
  view: NavigableViewKey;
  icon: ReactNode;
  /** Higher wins a place in the mobile tab bar, which fits three. */
  priority?: number;
}

export const navigation: NavigationEntry[] = [
  { view: 'home', icon: <Home className="size-4" aria-hidden />, priority: 100 },
];

/** The mobile bar shows the highest-priority entries and hides the rest. */
export const mobileNavigation: NavigationEntry[] = [...navigation].sort(
  (a, b) => (b.priority ?? 0) - (a.priority ?? 0),
);
